<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    ok-title="Create"
    size="lg"
    :title="modalTitle"
    title-tag="h5"
    cancel-title="Cancel"
    id="idBranchDetailImportModal"
    cancel-variant="outline-primary"
    :ok-disabled="droppedFile === null"
    @hidden="clearData"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <b-col>
          <b-form-file
            id="idFileDrop"
            v-model="droppedFile"
            browse-text="Browse"
            placeholder="Drag & Drop a file here"
          ></b-form-file>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      droppedFile: null,
    };
  },
  props: ["type"],
  created() {
  },
  computed: {
    modalTitle(){
      return `Import ${this.type} list for this branch`
    }
  },
  methods: {
    onOk() {
      this.$emit("import",
        this.droppedFile
      );
    },
    clearData() {
      this.droppedFile = null;
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin: 0.8rem 0;
}
</style>